// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLERS_COMPARISON = "Porovnej";
export const STROLLERS_COMPARISON_REMOVE_ALL = "Odeber v\u0161e";
export const STROLLERS_COMPARISON_TITLE = "Porovn\u00e1n\u00ed ko\u010d\u00e1rk\u016f";
export const STROLLER_SEO_GENERAL_DESC = "Velk\u00e1 datab\u00e1ze ko\u010d\u00e1rk\u016f Modr\u00e9ho kon\u00edka";
